<script lang="ts">
	import { real_id } from 'src/helpers/interface_helpers';

	//Services
	import { postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Select, toast } from '@Shelly/shelly-design-system';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;

	let value = settings.set_volume;
	let cache = value;
	let loading = false;

	let options = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
	const set_logic = async () => {
		if (cache !== value) {
			loading = true;
			const res = await postReq(`/device/sensor/gas_sensor_volume`, {
				id: device.id,
				volume: +value,
			});

			if (res.isok) {
				settings.set_volume = +value;
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('setting_err_toast') });
				value = cache;
			}
			loading = false;
		}
	};
	const change_value = (e) => {
		value = e.detail;
	};
</script>

<Select
	class="mb-s"
	size="m"
	value={options[options.indexOf(value.toString())]}
	{options}
	icon={'fas fa-volume'}
	on:change={change_value}
	id="select-w5vrgd8"
	aria-label={$format('set_volume', { default: 'Set volume' })}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={set_logic}
	>{$format('button_save')}</Button
>
